export interface IBankModel {
  id?: string;
  updated_at?: Date;
  created_at?: Date;
  is_active?: boolean;
  account_type?: any;
  bank_type?: any;
  account_name?: string;
  bank_name?: string;
  account_number?: string;
  branch_name_code?: string;
  swift_code?: string;
  created_by?: string;
  updated_by?: string;
  currency?: string;
  company?: string;
  documents?: any;
}

export interface IBankError {
  id?: string[];
  updated_at?: string[];
  created_at?: string[];
  is_active?: string[];
  account_type?: string[];
  bank_type?: string[];
  account_name?: string[];
  bank_name?: string[];
  account_number?: string[];
  branch_name_code?: string[];
  swift_code?: string[];
  created_by?: string[];
  updated_by?: string[];
  currency?: string[];
  company?: string[]
  documents?: string[]
}



export interface BankAndAccountType {
  value: number;
  display_name: string;
}

export class BankModel {
  id?: string;
  updated_at?: Date;
  created_at?: Date;
  is_active?: boolean;
  account_type?: any;
  bank_type?: any;
  account_name?: string;
  bank_name?: string;
  account_number?: string;
  branch_name_code?: string;
  swift_code?: string;
  created_by?: string;
  updated_by?: string;
  currency?: string;
  company?: string;
  documents?: any;

  error: IBankError;

  constructor() {
    this.id = null;
    this.updated_at = null;
    this.created_at = null;
    this.is_active = true;
    this.account_type = 2000;
    this.bank_type = 1000;
    this.account_name = null;
    this.bank_name = null;
    this.account_number = null;
    this.branch_name_code = null;
    this.swift_code = null;
    this.created_by = null;
    this.updated_by = null;
    this.currency = 'USD';
    this.company = null;
    this.documents = [];

    this.resetErrors();
  }

  resetErrors() {
    this.error = {
      is_active: [],
      account_type: [],
      bank_type: [],
      account_name: [],
      bank_name: [],
      account_number: [],
      branch_name_code: [],
      swift_code: [],
      currency: [],
      company: [],
      documents: [],
    }
  }

  savePayloadToModel(data: IBankModel) {
    this.id = data.id;
    this.updated_at = data.updated_at;
    this.created_at = data.created_at;
    this.is_active = data.is_active;
    this.account_type = data.account_type;
    this.bank_type = data.bank_type;
    this.account_name = data.account_name;
    this.bank_name = data.bank_name;
    this.account_number = data.account_number;
    this.branch_name_code = data.branch_name_code;
    this.swift_code = data.swift_code;
    this.created_by = data.created_by;
    this.updated_by = data.updated_by;
    this.currency = data.currency;
    this.company = data.company;
    this.documents = [...data.documents];
  }

  getSavePayload() {
    return {
      is_active: this.is_active,
      account_type: this.account_type,
      bank_type: this.bank_type,
      account_name: this.account_name,
      bank_name: this.bank_name,
      account_number: this.account_number,
      branch_name_code: this.branch_name_code,
      swift_code: this.swift_code,
      currency: this.currency,
      company: this.company,
      documents: this.documents.map((item) => item.id),
    }
  }
}